import { ColumnDef } from '@tanstack/react-table';
import { Stack } from 'react-bootstrap';
import { waitlistStatusColors } from '..';
import { Badge } from '../../../components/badge/Badge';
import { LinkCell } from '../../../components/tables/cellComponents/LinkCell';
import { userCanEditCreateDeleteView_Waitlist } from '../../../features/dash/views/schedule/waitlist/WaitlistView';
import { getCurrentUser } from '../../../services/helper';
import { Waitlist } from '../../../types/waitlist.type';
import { formatDate } from '../../dateUtils';

const currentUser = getCurrentUser();
export const waitlistColumns: ColumnDef<Waitlist>[] = [
  {
    header: 'ID',
    accessorKey: 'id'
  },
  {
    header: 'Session',
    accessorKey: 'course.title',
    cell: ({ row }) => (
      <LinkCell
        content={row.original.course.title}
        url={`/admin/schedule/sessions/${row.original.course.id}`}
      />
    )
  },
  {
    header: 'Child',
    accessorKey: 'child.full_name',
    cell: ({ row }) => (
      <LinkCell
          content={row.original.child.full_name}
          url={`/admin/sfc-users/children/${row.original.child.id}`}
      />
    )
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ getValue }) => (
      <Badge
        title={getValue<string>()}
        color={waitlistStatusColors[getValue<string>()]}
      />
    )
  },
  {
    header: 'Position',
    accessorKey: 'position'
  },
  {
    header: 'Total',
    accessorKey: 'total'
  },
  {
    header: 'Created At',
    accessorKey: 'created_at',
    cell: ({ getValue }) => formatDate(new Date(getValue<string>()), 'yyyy/MM/dd hh:mm z')
  },
  {
    header: 'Actions',
    id: 'actions',
    enableSorting: false,
    cell: ({ row }) => (
      <Stack
        direction="horizontal"
        gap={2}
      >
        <LinkCell
          content="View"
          url={`/admin/schedule/waitlists/${row.original.id}`}
          underline
        />
        {row.original.status !== 'archived' &&
          userCanEditCreateDeleteView_Waitlist(currentUser) && (
            <LinkCell
              content="Archive"
              url={`/admin/schedule/waitlists/${row.original.id}/archive`}
              underline
            />
          )}
      </Stack>
    )
  }
];
